export enum DeepDiveActions {
    Edit = "Edit Deep Dive",
    Upload = "Upload Deep Dive Content",
    SelectImage = "Select Deep Dive Image",
    Delete = "Delete Deep Dive",
}
